
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: {
    addonProp: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      loading: false,
      addons: {},
      valid: false,
      selectRule: [(v) => !!v || "Please select a type"]
    };
  },
  computed: {
    isNew() {
      return !(this.addonProp && this.addonProp.id);
    }
  },
  watch: {},
  mounted() {
    if (this.isNew) {
      this.initEmptyAddon();
    } else if (this.addonProp?.id) {
      this.addons = JSON.parse(JSON.stringify(this.addonProp));
    } else {
      this.getAddonDetail(this.$route.params.id).then((res) => {
        this.addons = res;
      });
    }
    this.$refs.form.resetValidation();
  },
  methods: {
    ...mapActions("menu", [
      "createAddon",
      "updateAddon",
      "getAddons",
      "getAddonDetail"
    ]),
    initEmptyAddon() {
      this.addons = {
        item_name: "",
        dish_type: "",
        item_short_description: "",
        item_unit_price: ""
      };
      this.$refs.form.resetValidation();
    },
    handleSubmit() {
      this.validate();
      if (!this.valid) return;
      if (this.isNew) {
        this.handleCreateAddon();
      } else {
        this.handleUpdateAddon();
      }
    },
    handleCreateAddon() {
      this.loading = true;
      this.createAddon({ addons: this.addons })
        .then((res) => {
          this.getAddons(true);
          this.$nuxt.$emit("show-toast", {
            text: "Item created successfully",
            color: "success darken-2",
            icon: "done",
            flat: true
          });

          this.$emit("open-addon-group-creation-dialog", res.data);
          this.initEmptyAddon();
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
          this.$emit("close-dialog");
        });
    },
    handleUpdateAddon() {
      this.loading = true;
      this.updateAddon({ addons: this.addons })
        .then((res) => {
          this.getAddons(true);
          this.$nuxt.$emit("show-toast", {
            text: "Item updated successfully",
            color: "success darken-2",
            icon: "done",
            flat: true
          });
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
          this.$emit("close-dialog");
        });
    },
    validate() {
      this.valid = this.$refs.form.validate();
    }
  }
};
